/**
 * ReonboardingGate (Task C4)
 *
 * 既存 OnboardingGuard の機能拡張版。
 * useReonboardingDecision で判定し:
 *   - kind=initial_full → /onboarding にリダイレクト
 *   - kind=version_diff/long_absence/plan_changed → 将来的にツアー発火 (現在は通過)
 *   - kind=none → 通常レンダリング
 *
 * /onboarding 自身では redirect ループを防ぐためチェックスキップ.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useReonboardingDecision } from '../../hooks/useReonboardingDecision';

interface Props {
  children: React.ReactNode;
}

export function ReonboardingGate({ children }: Props) {
  const decision = useReonboardingDecision();
  const location = useLocation();

  if (
    decision.redirectTo !== null &&
    location.pathname !== decision.redirectTo
  ) {
    return <Navigate to={decision.redirectTo} replace />;
  }

  return <>{children}</>;
}
